import PropTypes from 'prop-types';

import { types, weights, spacings, tags } from './constants';

const oneOfOrArrayIncludes = (values) => (props, propName, componentName) => {
    const prop = props[propName];
    const validValues = Object.values(values);

    if (Array.isArray(prop) && prop.every((value) => validValues.includes(value))) return null;
    else if (validValues.includes(prop)) return null;
    return new Error(`Invalid prop ${propName} supplied to ${componentName}. Validation failed.`);
};

export default {
    children: PropTypes.node.isRequired,
    type: oneOfOrArrayIncludes(types),
    weight: PropTypes.oneOf(Object.values(weights)),
    spacing: PropTypes.oneOf(Object.values(spacings)),
    tag: PropTypes.oneOf(Object.values(tags)),
    breakpoints: PropTypes.arrayOf(PropTypes.string),
    isItalic: PropTypes.bool,
    isLink: PropTypes.bool,
    isUppercase: PropTypes.bool,
    useBaseline: PropTypes.bool,
    dataId: PropTypes.string,
};
